"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var BaseModel_1 = require("./BaseModel");
var ContactRequest;
(function (ContactRequest) {
    var Create = (function (_super) {
        __extends(Create, _super);
        function Create() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.name = undefined;
            _this.email = undefined;
            _this.phone = undefined;
            _this.message = undefined;
            return _this;
        }
        return Create;
    }(BaseModel_1["default"]));
    ContactRequest.Create = Create;
})(ContactRequest = exports.ContactRequest || (exports.ContactRequest = {}));



//////////////////
// WEBPACK FOOTER
// ../model/dist/models/contact.js
// module id = ../model/dist/models/contact.js
// module chunks = main